const tokenMiddleware = (store) => (next) => (action) => {
  if (action.type.startsWith("loyalty/")) {
    const token = store.getState().loyalty.admin.token;
    if (token) {
      action.payload.headers = {
        ...action.payload.headers,
        Authorization: `Bearer ${token}`,
      };
    }
  }
  return next(action);
};

export default tokenMiddleware;
